import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import MenuPage from '@/pages/menu/page';
import AdminPage from '@/pages/admin/page';
import LegalPage from '@/pages/legal/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/menu', element: <MenuPage /> },
  { path: '/admin', element: <AdminPage /> },
  { path: '/impressum', element: <LegalPage /> },
  { path: '/datenschutz', element: <LegalPage /> },
  { path: '/agb', element: <LegalPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
